import React from 'react';
import { Glyphicon } from 'Elements';

const BetweenSteps = (props) => <div className="between_steps">
  <Glyphicon glyph="angle-right" className="text-secondary" />
</div>;

export default BetweenSteps;